import React from 'react';
import { PageTiles } from './view/pageTiles';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === '--PageTiles', 
  itemElt: (item, cmsOption) => <PageTiles item={item} cmsOption={cmsOption} />
}